import { useQuery } from '@tanstack/react-query'

import fetchRequest from './fetch-request'
import { QueryKeys } from './react-query'

const useGetCartCount = () => {
    const { data: cartCount, isLoading } = useQuery({
        queryKey: QueryKeys.Cart.CartCount,
        queryFn: () => fetchRequest({ serviceName: 'ntl', endpoint: '/carts/_my/items/count', method: 'GET' }),
    })

    return { isLoading, cartCount }
}

export default useGetCartCount
